import { Button, ButtonProps } from '@mui/material'
import { CatalogProductType } from '../enums'
import { useTranslation } from 'react-i18next'
import { useDialog } from '../hooks'
import CatalogProductCreateDialog from './CatalogProductCreateDialog'
import { CatalogProduct } from '../types'
import { Add } from '@mui/icons-material'

export interface CatalogProductCreateButtonProps
  extends Omit<ButtonProps, 'children' | 'onClick' | 'type'> {
  type?: CatalogProductType
  label?: string
  afterCreate?: (catalogProduct: CatalogProduct) => void
}

export default function CatalogProductCreateButton({
  type,
  label,
  afterCreate,
  ...props
}: CatalogProductCreateButtonProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation()

  /**
   * The dialog state.
   */
  const { open, openDialog, closeDialog } = useDialog()

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<Add />}
        {...props}
        onClick={openDialog}
      >
        {label ?? t('newCatalogProduct')}
      </Button>

      <CatalogProductCreateDialog
        type={type}
        open={open}
        onClose={closeDialog}
        afterCreate={afterCreate}
      />
    </>
  )
}
